<template>
	<div class="page">
		<top-header></top-header>
		<!--<h1 class="mt-2 text-center">Smart City</h1>-->
		<b-container fluid class="dashboard_ulb">
			<b-row class="my-4 mx-2 pb-3">
				<b-col lg="6" md="6" sm="12" >
					<div class="cont-box  m-0">
						<p class=" text-center text-white">{{ LocationName }} </p>
						<map-mh :records="records" :zones="zones"></map-mh>

						<!-- <gmap-map :center="{ lat: 28.207609, lng: 79.826660}" :zoom="7" class="googlemap">
						<gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWindowOpen" @closeclick="infoWindowOpen=false"></gmap-info-window>
						<gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :icon="m.icon" @click="toogleMarkerInfoWindow(m,index)"></gmap-marker>
					</gmap-map> -->

					</div>
					
			
					

				</b-col>
				<b-col lg="6" md="6" sm="12" class="text-center cont-box m-0">
					<b-card no-body class="chart-panel">
						<b-tabs pills card>
						<b-tab title="Pie Chart: CCMS" active> 
							<b-card-text class="text-white">Total CCMS : {{total_ccsm}}</b-card-text>
							<!--<b-img src="../assets/Group1226.svg" class="my-2 w-100" ></b-img> -->
							<pie-chart id="pie-chart-ccms" ref="ccms_piechartref" :data="sps_piedata" :options="sps_pieoptions" :height="250" /> 
						
						</b-tab>
						<b-tab title="Pie Chart: Street Lights"><b-card-text class="text-white">Total Street Light: {{totalSteel_Light}}</b-card-text>						
							<!-- <Bar :data="data" :options="options" />	 -->
							<pie-chart id="pie-chart-street-light" ref="sps_piechartref" :data="sps_piedata" :options="sps_pieoptions" :height="250" /> 
							<div class="note"> Note: data Showing in percentage (%)</div>
            
						</b-tab>
						</b-tabs>
					</b-card>
					
				</b-col>
				
			</b-row>
		</b-container>
		<!-- <b-container fluid>
			<b-row class="my-2">
				<b-col cols="3">
					<b-img :src="$session.get('weburl')+'/images/'+$session.get('user_info').permissions.logo_left" v-if="$session.get('user_info').permissions.logo_left!=''" style="max-width:100px;" class="my-2"></b-img>
				</b-col>
				<b-col cols="6" class="text-center">
					<b-img :src="$session.get('weburl')+'/images/'+$session.get('user_info').permissions.logo_center" v-if="$session.get('user_info').permissions.logo_center!=''" class="my-2" style="max-width:120px;"></b-img>
				</b-col>
				<b-col cols="3" class="text-right">
					<b-img :src="$session.get('weburl')+'/images/'+$session.get('user_info').permissions.logo_right" style="max-width:100px;" class="mr-2 my-2"></b-img>
				</b-col>
			</b-row>
		</b-container> -->
		<!-- <b-container fluid>
			<b-row class="px-2">
				
							<b-col class="px-2">
								<b-card img-src="../assets/ulbs.svg" img-alt="Card image" img-left class="info-box mb-3">
									<h6>Total ULBs</h6>
									<b-card-text>
										{{records.length}} <small>ULBs</small>
									</b-card-text>
								</b-card>
							</b-col>
							<b-col class="px-2">
								
									<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3">
										<h6>Total CCMS</h6>
										<b-card-text>
											{{total_device}}
										</b-card-text>
									</b-card>
							
							</b-col>
							<b-col class="px-2">
								<b-card img-src="../assets/dcu-connection.svg" img-alt="Card image" img-left class="info-box mb-3">
									<h6>Connected CCMS</h6>
									<b-card-text>
										{{total_device_on}}
									</b-card-text>
								</b-card>
							</b-col>
							<b-col class="px-2">
								<b-card img-src="../assets/power-cut.svg" img-alt="Card image" img-left class="info-box mb-3">
									<h6>Power Cut</h6>
									<b-card-text>
										{{poweroff_devices}}
									</b-card-text>
								</b-card>
							</b-col>
							<b-col class="px-2">
								<b-card img-src="../assets/no-light.svg" img-alt="Card image" img-left class="info-box mb-3">
									<h6>Temp. Signal Loss</h6>
									<b-card-text>
										{{total_device_loss}}
									</b-card-text>
								</b-card>
							</b-col>
						</b-row>
						<b-row class="px-2">
							<b-col class="px-2">
								<b-card img-src="../assets/street-light.svg" img-alt="Card image" img-left class="info-box mb-3">
									<h6>Total Lights</h6>
									<b-card-text>
										{{total_controller}}
									</b-card-text>
								</b-card>
							</b-col>
							<b-col class="px-2">
								<b-card img-src="../assets/light-on.svg" img-alt="Card image" img-left class="info-box mb-3 bg-green">
									<h6>Total Light ON</h6>
									<b-card-text>
										{{total_controller_on}} <small>({{ $root.tofixed((total_controller_on/total_controller)*100, 2) }}%)</small>
									</b-card-text>
								</b-card>
							</b-col>
							<b-col class="px-2">
								<b-card img-src="../assets/light-off.svg" img-alt="Card image" img-left class="info-box mb-3 bg-red">
									<h6>Total Light OFF</h6>
									<b-card-text>
										{{total_controller_off}} <small>({{ $root.tofixed((total_controller_off/total_controller)*100, 2) }}%)</small>
									</b-card-text>
								</b-card>
							</b-col>
							<b-col class="px-2">
								<b-card img-src="../assets/no-light.svg" img-alt="Card image" img-left class="info-box mb-3 bg-orange">
									<h6>Temp. Signal Loss</h6>
									<b-card-text>
										{{total_controller_loss}} <small>({{ $root.tofixed((total_controller_loss/total_controller)*100, 2) }}%)</small>
									</b-card-text>
								</b-card>
							</b-col>
							<b-col class="px-2">
								<b-card img-src="../assets/plugs.svg" img-alt="Card image" img-left class="info-box mb-3">
									<h6>Connected</h6>
									<b-card-text>
										{{(total_controller - total_controller_loss)}}
									</b-card-text>
								</b-card>
							</b-col>
						</b-row>
						<b-row class="px-2">
							<b-col class="px-2">
								<b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
									<h6>Total Load</h6>
									<b-card-text>
										{{total_load/1000}} <small>KW</small>
									</b-card-text>
								</b-card>
							</b-col>
							<b-col class="px-2">
								<b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
									<h6>Active Load</h6>
									<b-card-text>
										{{current_load}} <small>KW</small>
									</b-card-text>
								</b-card>
							</b-col>
							<b-col class="px-2">
								<b-card img-src="../assets/green-energy.svg" img-alt="Card image" img-left class="info-box mb-3">
									<h6>Energy Saving Per Year</h6>
									<b-card-text>
										{{ $root.tofixed(energy_saving_per_year, 3) }} <small>MU</small>
									</b-card-text>
								</b-card>
							</b-col>
							<b-col class="px-2">
								<b-card img-src="../assets/save-money.svg" img-alt="Card image" img-left class="info-box mb-3">
									<h6>Revenue Saving Per Year</h6>
									<b-card-text>
										₹ {{ $root.tofixed(revenue_saving_per_year, 4) }} <small>Crores</small>
									</b-card-text>
								</b-card>
							</b-col>
							<b-col class="px-2">
								<b-card img-src="../assets/save-money.svg" img-alt="Card image" img-left class="info-box mb-3">
									<h6>CO2 Reduction Per Year</h6>
									<b-card-text>
										{{  $root.tofixed(energy_saving_per_year * 0.82, 2)  }} <small>Million Tons</small>
									</b-card-text>
								</b-card>
							</b-col>
					
			</b-row>
			
		</b-container> -->
		
		<!-- <b-container fluid>
			<b-row class="my-3">
				<b-col md="8" offset-md="2">
				
					<map-mh :records="records" :zones="zones"></map-mh>
				</b-col>
			</b-row>
		</b-container> -->
		<!-- <b-container fluid>
			<b-row class="my-2">
				<b-col>
					<h2 class="text-center my-4">Live Push Data</h2>
				</b-col>
			</b-row>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">

									<template v-slot:cell(city_title)="row">
										<b-link  @click="showCcmschart(row.item)">{{row.value}}</b-link>
									</template>
									<template v-slot:cell(ulb_title)="row">
										<b-link :href="'/devices/'+row.item.ulb_areacode">{{row.value}}</b-link>
									</template>
									<template v-slot:cell(output_status)="row">
										<b-badge pill variant="success" v-if="row.value == 1">ON</b-badge>
										<b-badge pill variant="danger" v-else>OFF</b-badge>
									</template>
									<template v-slot:cell(door_status)="row">
										<b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>
										<b-badge pill variant="success" v-else>CLOSED</b-badge>
									</template>
									<template v-slot:cell(imei_no)="row">
										<b-link :href="'/device-data/'+row.value">{{row.value}}</b-link>
									</template>
									<template v-slot:cell(network)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">DISCONNECTED</b-badge>
										<b-badge pill variant="success" v-else>CONNECTED</b-badge>
									</template>
									<template v-slot:cell(actions)="row">
										<b-link :href="'/livedata/'+row.item.ulb_areacode">Live</b-link>
										//<b-button pill variant="info" class="mr-1" @click="$router.push('/report-ulb/'+row.item.ulb_areacode);" size="sm">Report</b-button> 
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row> 
		</b-container> -->
		<top-footer></top-footer>
		<!-- <search-sidebar></search-sidebar> -->
	</div>
</template>
<script>
import Header from "@/components/Header.vue";
//import MHmap from "@/components/maps/MH.vue";
import MHmap from "@/components/maps/UP.vue";
/*import MHmap from './../../public/mh-map.svg';*/
//import Search from "@/components/Search.vue";



import Footer from "@/components/Footer.vue";
//import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Pie } from 'vue-chartjs';

export default {
	name: 'Login',
	components: {
		"top-header": Header,
		"map-mh": MHmap,
		//"search-sidebar": Search,
		"top-footer": Footer,
		"pie-chart": Pie,
		
	},
	beforeCreate: function() {
        document.body.className = 'page';
	},
	beforeDestroy(){
		console.log("CLEAR INTERVAL DASHBOARD");
		clearInterval(this.interval);
	},
	mounted(){
		this.initload();
	},
	data() {
		var self = this;
	
		return{
			email: '',
			password: '',
			interval: '',
			url: self.$session.get('apiurl')+'aligarhapi/dashboard',
			devices: [],
			controllers: [],
			total_device: 0,
			total_device_on: 0,
			total_device_loss: 0,
			connected_controllers: 0,
			total_controller: 0,
			total_controller_on: 0,
			total_controller_off: 0,
			total_controller_loss: 0,
			connected_devices: 0,
			poweroff_devices: 0,
			dashboard_data: {},
			total_load: 0,
			previous_load: 0,
			current_load: 0,
			energy_saving_per_year: 0,
			revenue_saving_per_year: 0,
			selected_region: {'state':self.$route.params.stateid},
			zones: [],
			records: [],
			fields: [
				{ key: 'state_id', label: 'State', sortable: true, sortDirection: 'desc' , 
					formatter: (value) => {
						for (var i = 0; i < self.$root.state_options.length; i++) {
							if(self.$root.state_options[i].value == value){
								return self.$root.state_options[i].text;
							}
						}
						return value;
					},
				},
				{ key: 'city_title', label: 'District.', sortable: true, class: 'text-center' },
				{ key: 'ulb_title', label: 'ULB', sortable: false,	sortByFormatted: true, filterByFormatted: true },
				{ key: 'total_controller', label: 'Total Lights' },
				{ key: 'total_controller_on', label: 'Lights ON' },
				{ key: 'total_controller_off', label: 'Lights OFF' },
				{ key: 'total_controller_loss', label: 'Signal Loss (LIGHTS)' },
				{ key: 'total_device', label: 'Total CCMS' },
				{ key: 'total_device_on', label: 'CCMS ON' },
				{ key: 'total_device_off', label: 'CCMS OFF' },
				{ key: 'total_device_loss', label: 'Signal Loss (CCMS)' },
				{ key: 'total_powercut', label: 'Power Cut' },
				{ key: 'total_manual_on', label: 'Manual ON' },
				{ key: 'total_load', label: 'Total Load' ,
					formatter: (value) => { 
						return (value/1000).toFixed(3);
					},
				},
				{ key: 'actual_load', label: 'Active Load',
					formatter: (value) => { 
						return (value/100000).toFixed(3);
					},
				},
				{ key: 'total_kwh', label: 'Total KWH',
					formatter: (value) => {
						return (value/100).toFixed(2);
					}
				},
				{ key: 'update_time', label: 'TimeStamp', 
					formatter: (value, key, item) => {
						if(item.update_time == ""){
							return '00-00-0000 00:00:00';
						}
						return self.$moment(item.update_time).format('DD-MM-YYYY HH:mm');
					},
				},
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],	
			ccms_piechartref:[],		
			sps_piechartref:[],
			sps_piedata:'',
			sps_pieoptions:'',
			total_ccsm:0,
			totalSteel_Light:0,
			map_center: { lat: 41.693206, lng: -86.228631 }, 
			infoOptions: {
				content: '',
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
			infoWindowPos: null,
			infoWindowOpen: false,
			markers:[],
			LocationName:'',

			
			
		};
	},
	methods: {
		
		initload(){
			var self = this;
			self.axios.post(self.url, {
				accesskey: self.$session.get('access_key'),
				state_perm: self.$route.params.stateid
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
				//	self.devices = response.data.result.devices;
					self.controllers = response.data.result.controllers;

					self.dashboard_data = response.data.result;
					self.records = response.data.result.records;
					self.zones = response.data.result.zones;

					self.totalRows = self.records.length;

					self.total_device = 0;
					self.total_device_on = 0;
					self.total_device_off = 0;
					self.total_device_loss = 0;

					self.total_controller = 0;
					self.total_controller_on = 0;
					self.total_controller_off = 0;
					self.total_controller_loss = 0;
					
					self.connected_devices = 0;
					self.poweroff_devices = 0;

					self.total_load = 0;
					self.current_load = 0;
					var chartItems = {
						total_device_on: 0,
						total_device_off: 0,
						total_device_loss: 0,
						total_powercut: 0,
						total_controller_on: 0,
						total_controller_off: 0,
						total_controller_loss: 0
						};

					var min_lat = 100;
					var min_lng = 100;
					var max_lat = 0;
					var max_lng = 0;
					self.markers = [];
					var geoloc = [];
					var l=0;
					self.records.forEach(function(item){
						self.total_controller += item.total_controller;
						self.total_device += item.total_device;
						self.total_device_loss += item.total_device_loss;
						self.total_controller_on += item.total_controller_on;
						self.total_controller_off += item.total_controller_off;
						self.total_controller_loss += item.total_controller_loss;

						self.total_load += parseFloat(item.total_load);
						self.previous_load += parseFloat(item.previous_load);
						self.current_load += parseFloat(item.actual_load);

						//	console.log(item.previous_load+' '+item.total_load+' '+item.tariff_rate);
						var saving = 12 * 365 * (parseFloat(item.previous_load) - (parseFloat(item.total_load)/1000));
						self.energy_saving_per_year = saving/1000000;
						self.revenue_saving_per_year = saving/10000000 * parseFloat(item.tariff_rate);

						self.poweroff_devices += item.total_powercut;

						
						/* ==================================  */
						var ulbId = item.ulb_id;

							chartItems.total_device_on += item.total_device_on || 0;
							chartItems.total_device_off += item.total_device_off || 0;
							chartItems.total_device_loss += item.total_device_loss || 0;
							chartItems.total_powercut += item.total_powercut || 0;

							chartItems.total_controller_on += item.total_controller_on || 0;
							chartItems.total_controller_off += item.total_controller_off || 0;
							chartItems.total_controller_loss += item.total_controller_loss || 0;

						if(l==1){
							//self.showCcmschart(item);
							self.LocationName = 'Nagar Nigam Aligarh'; //self.$root.ulb_location[ulbId]['name'];

						}
						/* ------------ Map ploating ----------------- */
							
								
							
							if(Object.hasOwn(self.$root.ulb_location, ulbId)){		
							var location_lat = self.$root.ulb_location[ulbId]['lat']; 	
							var location_lng = self.$root.ulb_location[ulbId]['lng'];			
							var blueurl = "https://www.fablurs.com/flag-blue.png";
							var iconurl = blueurl;
							var moreINfo ='/devices/'+item.ulb_areacode;
							var msg = '<b> <h6 style="color:#FF9F43">'+self.$root.ulb_location[ulbId]['name']+'</h6></b><a href="'+moreINfo+'" ><span style="color: #fff; background-color: #17a2b8;padding-right: 0.6em;padding-left: 0.6em;border-radius: 10rem;font-size: 11px;">More Details</span></a>';		

							min_lat = Math.min(location_lat, min_lat);
							min_lng = Math.min(location_lng, min_lng);
							max_lat = Math.max(location_lat, max_lat);
							max_lng = Math.max(location_lng, max_lng);


							geoloc.push(self.addMarker(location_lat,location_lng, msg, iconurl,item)); 
							}
						/* ================================== */						
						
							l++;
					});
					self.markers = geoloc;
					self.center = { lat: min_lat + (max_lat - min_lat)/2, lng: min_lng + (max_lng - min_lng)/2 };
					self.showCcmschart(chartItems);
					console.log('chartItems',	chartItems);

					self.total_device_on = self.total_device - self.total_device_loss;					
					self.interval = setTimeout(self.initload, self.$root.reload_duration);
					//alert(JSON.stringify(response.data.result.devices));
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				self.interval = setTimeout(self.initload, self.$root.reload_duration);
				console.log(error);
			});
			

			


		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		showCcmschart(items){	

			var self = this;
			console.log("state:"+items);
			console.log("state:"+JSON.stringify(items));
			console.log("state:"+items.ulb_id);
			/* ----------CCMS Chart Start----------  */
			var ccms_On 	= items.total_device_on;
			var ccms_off 	= items.total_device_off;
			var signal_lose = items.total_device_loss;
			var power_cut 	= items.total_powercut;

			/* var overload 	= items.actual_load;
			var underload 	= items.total_load;  */ 
			
			self.total_ccsm = Number(ccms_On)+ Number(ccms_off)+Number(signal_lose);
			//self.LocationName = items.city_title;
			

			var _labels_ccms = [ 
							"CCMS On",
							"CCMS Off",
							"Signal Loss",
							"Power Cut",
							/* "Underload",
							"Signal Lose", */
						];
			var _datasets_ccms = [
			{
				backgroundColor: ["#0F9D58", '#F4511E',"#AEAEAE","#E4AD00"], 
				data: [ccms_On,ccms_off,signal_lose,power_cut]
			}
			];


			self.$refs.ccms_piechartref.renderChart(
              {
                labels: _labels_ccms,
                datasets: _datasets_ccms
              },
              {
                legend: {
                  position: "bottom",
				  labels:{
					fontColor:'#ffffff'
				  }
                }
              }
            );

			/* -------Ccms Chart end------- */

			/* ------- Ccms Light Chart Start ------ */


			var lights_on 			= items.total_controller_on;
			var lights_off 			= items.total_controller_off;
			var signal_lose_lights 	= items.total_controller_loss;
			self.totalSteel_Light 	= Number(lights_on)+Number(lights_off)+Number(signal_lose_lights);

			  /* **** Custome code By vijay **** */
			 var last_sync_time = self.$moment(items.update_time).format('YYYY-MM-DD HH:mm:ss');
               var on_time =  self.zones[0].on_time;
               var off_time =  self.zones[0].off_time;
               //var inschedule = self.in_schedule(last_sync_time, self.zones.on_time, self.zones.off_time);
            var inschedule = self.in_schedule(last_sync_time, on_time, off_time);
			//console.log(JSON.stringify(self.zones),'::::::::::', self.zones[0].off_time);
			//console.log(last_sync_time,':::',inschedule,'::::::::total_signal_loss:',signal_lose_lights)
			//const totalr =signal_lose_lights;
                if (inschedule) {
                    lights_on += signal_lose_lights;
					signal_lose_lights =0;
                } else {	
                    lights_off += signal_lose_lights;
					signal_lose_lights =0;
                }

			/* ********************  */
			lights_on = self.$root.tofixed((lights_on/self.totalSteel_Light)*100, 2);
			lights_off = self.$root.tofixed((lights_off/self.totalSteel_Light)*100, 2);
			signal_lose_lights = self.$root.tofixed((signal_lose_lights/self.totalSteel_Light)*100, 2);
			
		
			var _labels = [
			"Lights On",
			"Lights Off",
			"Signal Lose",
            ];
            var _datasets = [
              {
                backgroundColor: ["#0F9D58","#AEAEAE", "#4285F4"],
                data: [lights_on,lights_off,signal_lose_lights]
              }
            ];

            self.$refs.sps_piechartref.renderChart(
              {
                labels: _labels,
                datasets: _datasets
              },
              {
                legend: {	

                  position: "bottom",
				  labels:{
					fontColor:'#ffffff'
				  }
                }
              }
            );

			


		},
		setCenter () {
		this.map_center = {lat: '41.9028', lng: '12.4964'}
		},
		toogleMarkerInfoWindow(marker, index){
			this.showCcmschart(marker.item);
			console.log('Mylocation:'+JSON.stringify(marker.position));
			this.infoWindowPos = marker.position;
			this.infoOptions.content = marker.infotext;
			if(this.currentMarkerIndex == index){
				this.infoWindowOpen = !this.infoWindowOpen;
			}else{
				this.infoWindowOpen = true;
				this.currentMarkerIndex = index;
			}
		},
		addMarker(lat, lng, infotext, iconurl,item) {
			const marker = {
				lat: lat,
				lng: lng
			};
			return { position: marker, infotext: infotext, icon: {url:iconurl,size: {width: 20, height: 28, f: 'px', b: 'px'}, scaledSize: {width: 20, height: 28, f: 'px', b: 'px',}},item:item };
			//this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
			//this.places.push(this.currentPlace);
			//this.center = marker;
			//this.currentPlace = null;
		},
		in_schedule(curr_time, start_time, end_time){
			var self = this;
			if(start_time != '' && end_time!= '' && start_time != null && end_time!= null){
				var cal_start_time = parseFloat(start_time.split(":")[0]+'.'+start_time.split(":")[1]);
				var cal_end_time = parseFloat(end_time.split(":")[0]+'.'+end_time.split(":")[1]);
				var cal_curr_time = self.$moment(curr_time).format("HH.mm");

				var start_date = '';
				//var end_date = '';
				if(cal_start_time > cal_end_time){
					//console.log('>>> '+curr_time);
					if(cal_curr_time <= 24.00 && cal_curr_time > cal_start_time){
						//console.log(self.$moment(curr_time).format("YYYY-MM-DD"));
						start_date = self.$moment(curr_time).format("YYYY-MM-DD")+" "+start_time;
					//	end_date = self.$moment(curr_time).add(1, 'day').format("YYYY-MM-DD")+" "+end_time;
					}else if(cal_curr_time < cal_end_time){
						//console.log("ELSE IF");
						start_date = self.$moment(curr_time).subtract(1, 'day').format("YYYY-MM-DD")+" "+start_time;
					//	end_date = self.$moment(curr_time).format("YYYY-MM-DD")+" "+end_time;
					}else{
						//console.log("ELSE ");
						start_date = self.$moment(curr_time).format("YYYY-MM-DD")+" "+start_time;
					//	end_date = self.$moment(curr_time).add(1, 'day').format("YYYY-MM-DD")+" "+end_time;
					}
				}else{
					start_date = self.$moment(curr_time).format("YYYY-MM-DD")+" "+start_time;
				//	end_date = self.$moment(curr_time).format("YYYY-MM-DD")+" "+end_time;
				}
				//console.log(start_date);
				if(self.$moment(curr_time).diff(start_date, 'minutes') > 0){
					return true;
				}
			}
			return false;
		},
	}
}
</script>
<style lang="scss" >
html{
	min-height: 100%;
}
/* body{
	background-color: '#FFF' !important;
	background-image: none !important;
} */
.page{
	padding-top: 48px;
}

.dashboard_ulb{
	background-image: url(../assets/home-banner.png) !important;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
	padding-top: 10px;
}
.cont-box{	
	border:1px solid #c6c6c6;
	border-radius: 20px;
    opacity: 1;   
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    height: auto;
	/* background: #ffffff80 !important; */
	background: transparent;
	padding: 7px;
	.chart-panel {	 
		background: none;
		.card-header{
		padding: 5px 0px 5px 19px;
		background: #fff;
		border-radius: 5px;
		}
		.nave-link{
			padding: 4px;
		}
		.nav-item {
			width: 49%;
			.active{    background: #ffc107;}
			.nav-link{
				padding: 4px;
			}
		}
	}

}
	

.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}

.mt-xl{
	margin-top: 100px;
}
.btn-black{
	background-color: #000;
	color: #FFF;
	padding: 6px 25px;
}
.info-box2{
	display: block;
	min-height: 90px;
	background-color: #FFF;
	width: 100%;
	box-shadow: 0 1px 1px rgba(0,0,0,0.1);
	border-radius: 2px;
    margin-bottom: 15px;
}
.googlemap{
	height: 520px;
	border:1px solid #c6c6c6;
	border-radius: 20px;
}

.vue-map{
	border-radius: 20px;
}
.note{position: absolute;
    text-align: center;
    color: #fff;
    font-size: 12px;
    width: 91%;}

</style>